<script setup lang="ts">
import type { InputOtpProps } from "./inputOtp.types";
import { useInputOtp } from "./useInputOtp";
import { VisuallyHiddenInput } from "components/VisuallyHidden";

defineOptions({ name: "EInputOtp" });

const props = withDefaults(defineProps<InputOtpProps>(), {
  length: 6,
  type: "number",
  mask: false,
});

const { fieldValues, fieldIndexes, inputType, inputmode, currentValue, wrapperClasses } = useInputOtp({ props });
</script>

<template>
  <div part="base" :class="wrapperClasses">
    <e-group :size="size">
      <e-input
        v-for="index in fieldIndexes"
        :key="index"
        :model-value="fieldValues[index]"
        :type="inputType"
        :size="size"
        :variant="variant"
        :color="color"
        :disabled="disabled"
        :placeholder="placeholder"
        square
        maxlength="1"
        autocomplete="off"
        class="text-center"
        :inputmode="inputmode"
      />
    </e-group>

    <visually-hidden-input v-if="name" :name="name" :value="currentValue" :disabled="disabled" :required="required" />
  </div>
</template>
